import { render, staticRenderFns } from "./ModalFull.vue?vue&type=template&id=275bed34&"
import script from "./ModalFull.vue?vue&type=script&lang=ts&"
export * from "./ModalFull.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports